<div class="card-team d-flex">
  <div class="picture">
    <img
      *ngIf="
        data.image !== null && data.image !== undefined && data.image !== ''
      "
      src="{{ data.image }}"
      class="img-fluid"
    />
    <span
      *ngIf="data.image == null || data.image == undefined || data.image == ''"
      class="vname"
      >{{ data.name | initials }}</span
    >
  </div>

  <div class="team-content">
    <span class="name">{{ data.name }}</span>
    <span class="title">{{ data.role }}</span>
    <span class="date">{{ data.date | date }}</span>
    <a href="mailto:{{ data.email }}" class="mailto-text">{{ data.email }}</a>
    <div class="sociallinks">
      <a *ngIf="data.linkdin !== undefined && data.linkdin !== null && data.linkdin !== '' "
        href="{{ data.linkdin }}"
        target="_blank"
        class="linkdn-icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1233_14858)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.429 6.969H11.143V8.819C11.678 7.755 13.05 6.799 15.111 6.799C19.062 6.799 20 8.917 20 12.803V20H16V13.688C16 11.475 15.465 10.227 14.103 10.227C12.214 10.227 11.429 11.572 11.429 13.687V20H7.429V6.969ZM0.57 19.83H4.57V6.799H0.57V19.83ZM5.143 2.55C5.14315 2.88528 5.07666 3.21724 4.94739 3.52659C4.81812 3.83594 4.62865 4.11651 4.39 4.352C3.9064 4.83262 3.25181 5.10165 2.57 5.1C1.88939 5.09954 1.23631 4.8312 0.752 4.353C0.514211 4.11671 0.325386 3.83582 0.196344 3.52643C0.0673015 3.21704 0.000579132 2.88522 0 2.55C0 1.873 0.27 1.225 0.753 0.747C1.23689 0.268158 1.89024 -0.000299211 2.571 2.50265e-07C3.253 2.50265e-07 3.907 0.269 4.39 0.747C4.872 1.225 5.143 1.873 5.143 2.55Z" fill="black"/>
          </g>
          <defs>
          <clipPath id="clip0_1233_14858">
          <rect width="20" height="20" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </a>
      <!-- <a href="#"
      target="_blank"
      class="twitter-icon">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1233_14856)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 20L12.1787 8.34363L12.1921 8.35455L19.2441 0H16.8875L11.1427 6.8L6.58068 0H0.400171L7.70208 10.8828L7.7012 10.8818L0 20H2.3566L8.74345 12.4346L13.8195 20H20ZM5.64694 1.81818L16.6207 18.1818H14.7532L3.77059 1.81818H5.64694Z" fill="black"/>
        </g>
        <defs>
        <clipPath id="clip0_1233_14856">
        <rect width="20" height="20" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      </a> -->
    </div>
  </div>
</div>
